import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { QuickbooksDisclaimerComponent } from './quickbooks.disclaimer.component';
import { QuickbooksService }             from '../quickbooks/quickbooks.service';
import { SharedModule }                  from '../shared/shared.module';
import { SyncQuickbooksComponent }       from './quickbooks.sync.component';

@NgModule({
  declarations: [
    QuickbooksDisclaimerComponent,
    SyncQuickbooksComponent
  ],
  entryComponents: [
    QuickbooksDisclaimerComponent,
    SyncQuickbooksComponent
  ],
  exports: [
    QuickbooksDisclaimerComponent,
    SyncQuickbooksComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    QuickbooksService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class QuickbooksModule {}
